import { StyledWidget, StyledButton } from '@/components/styles';
import { useEffect, useState } from 'react';
import Icon from '@/assets/icons';
import * as gtag from '@/lib/gtag';
import getCookie from '@/lib/getCookie';

export default function ContactWidgetButton({ fixed = true }) {
  const [gclid, setGclid] = useState(null);
  const [fbclid, setFbclid] = useState(null);
  const [wbraid, setWbraid] = useState(null);
  const [gbraid, setGbraid] = useState(null);

  let _href = 'https://wa.me/97143830500?text=Здравствуйте!%20Пишу%20с%20сайта%20—%20https://elemental.ae/%20';
  if (gclid) {
    _href += `(gclid:${gclid}) `;
  }
  if (fbclid) {
    _href += `(fbclid:${fbclid}) `;
  }
  if (wbraid) {
    _href += `(wbraid:${wbraid}) `;
  }
  if (gbraid) {
    _href += `(gbraid:${gbraid})`;
  }

  useEffect(() => {
    setGclid(getCookie('gclid'));
    setFbclid(getCookie('fbclid'));
    setWbraid(getCookie('wbraid'));
    setGbraid(getCookie('gbraid'));
  }, []);

  return (
    <StyledWidget static={!fixed}>
      <StyledWidget.Button
        green
        as="a"
        href={_href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => {
          gtag.gtag_report_conversion('AW-18230806173/O4BNCKbCvMAcEJ2NkPVD');
        }}
      >
        <Icon name="whatsapp" fill="white" width={30} height={30} />
      </StyledWidget.Button>
    </StyledWidget>
  );
}
